import { useTranslation } from 'react-i18next';
import { createPortal } from 'react-dom';
import { useEffect, useRef } from 'react';

export function LineDistanceEntry({ value, onChange, onCommit, onCancel, directionReady }: {
  value: string;
  onChange: (value: string) => void;
  onCommit: () => void;
  onCancel: () => void;
  directionReady: boolean;
}) {
  const { t } = useTranslation();
  const inputRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    // The first scene click captures the pointer. Focus after that click finishes.
    const timer = window.setTimeout(() => inputRef.current?.focus(), 0);
    return () => window.clearTimeout(timer);
  }, []);
  const validLength = Number.isFinite(Number(value)) && Number(value) > 0;
  const slot = document.getElementById('line-length-slot');
  if (!slot) return null;
  return createPortal(<div className="line-distance-entry" onPointerDown={(event) => event.stopPropagation()} title={t('line.clickDirectionHint')}>
    <label htmlFor="line-distance-mm">{t('line.length')} (mm)</label><input ref={inputRef} id="line-distance-mm" type="number" min="0.001" step="1" inputMode="decimal" value={value} onChange={(event) => onChange(event.target.value)} onKeyDown={(event) => {
      event.stopPropagation();
      if (event.key === 'Enter') { event.preventDefault(); if (directionReady && validLength) onCommit(); }
      if (event.key === 'Escape') { event.preventDefault(); onCancel(); }
    }} /><button type="button" disabled={!directionReady || !validLength} onClick={onCommit}>{t('line.create')}</button>
  </div>, slot);
}
